import React, {useState, useCallback, useEffect} from 'react'
import { useHistory, useRouteMatch, Switch, Route, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { getClientDetails } from '../../redux/actions/clientShortInfoAction'
import ClientShortInfo from './ClientShortInfo/ClientShortInfo'
import ClientInfoTab from './ClientInfoTab/ClientInfoTab'
import ClientContractTab from './ClientContractTab/ClientContractTab'
import ClientContractAdd from './ClientContractAdd'
import ClientContract from './ClientContract/ClientContract'
import { Message } from '../utilites'
import { BackButton } from '../common'

import './client.scss'
import Loader from "../Users/Loader/Loader";

const INFO = 'info'
const CONTRACTS = 'contracts'
const CONTRACT = 'contract'
const NEW_CONTRACT = 'new_contract'

const Client = ({setTitlePage}) => {
  const dispatch = useDispatch();
  const { commonError } = useSelector(({ contract }) => contract)
  const {commonError: cashBoxError} = useSelector(({ handbook }) => handbook);
  const { commonError: clientError } = useSelector(({ clientInfo }) => clientInfo);
  const {accessFeatures, isLoadingConfiguration}= useSelector(({user}) => user);
  const {
    commonError: userError
  } = useSelector(({ user }) => user)
  const [error, setError] = useState(null)
  const [activeInfoTab, setActiveInfoTab] = useState(0);
  const history = useHistory()
  const match = useRouteMatch()
  const path = match.url
  const clientId = match.params.id
  const isQuickCalculation = history.location?.state?.isQuickCalculation ? null : true

  const onError = useCallback(error => setError(error), [])

  const handleTabChange = (newTab) => setActiveInfoTab(newTab);

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Профиль клиента');
  }, [isLoadingConfiguration]);

  useEffect(() => {
    dispatch(getClientDetails(clientId));
  }, [clientId]);

  const currentTab = () => {
    let pathname = history.location.pathname
    let tab = pathname.split(path)[1]
    switch (tab) {
      case '/contract':
        return NEW_CONTRACT
      case '/contracts':
        return CONTRACTS
      default: {
        if (tab.indexOf('/contracts/') !== -1) {
          return CONTRACT
        }
        return INFO
      }
    }
  }

  let tabName = currentTab()

  return (
    <main className='app-content'>
      {
        isLoadingConfiguration ?
          (<div className="content-inner">
              <Loader pageRange={1}/>
            </div>) :
     (<>
      <div className={accessFeatures['title.header_section'] ? '' : 'content-header'}>
        {
          isQuickCalculation &&
          <div className={accessFeatures['title.header_section'] ? 'content-header-back-without-title' : 'content-header-back'}>
            <BackButton />
          </div>
        }
        {!accessFeatures['title.header_section'] && <h1>Профиль клиента</h1>}
      </div>
      <div className='content-inner'>
        <div className='content-inner-data'>
          {(commonError || userError || error || clientError || cashBoxError) && <Message type='error' text={commonError || userError || error || clientError || cashBoxError} />}

          <div className='content-inner-data-container m-b-spacer-2'>
            <ClientShortInfo activeInfoTab={activeInfoTab} />
          </div>
          <div className='content-tabs'>
            <Link to={`${path}/contracts`}
                  className={tabName === CONTRACTS ? 'content-tabtrigger button-white active' : 'content-tabtrigger button-white'}>Договоры</Link>
            <Link to={`${path}`}
                  className={tabName === INFO ? 'content-tabtrigger button-white active' : 'content-tabtrigger button-white'}>Анкета</Link>
          </div>

          <Switch>
            <Route
              path={`${path}`}
              exact
              render={() =>
                <ClientInfoTab clientId={clientId} onTabChange={handleTabChange} />
              } />
            <Route
              path={`${path}/contracts`}
              exact
              render={() =>
                <ClientContractTab />
              } />
            <Route
              path={`${path}/contracts/:contractId`}
              exact
              render={() =>
                <ClientContract />
              } />
            <Route
              path={`${path}/contract`}
              exact
              render={() =>
                <ClientContractAdd onError={onError} />
              } />
          </Switch>

        </div>
      </div>
      </>)
      }

    </main>
  )
}

export default Client
